import { faShield } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useLocation } from "react-router-dom";

const GGABtn = ({ ggaEnabled, handleGGANav }) => {
  const location = useLocation();
  return (
    <button
      disabled={location && location.pathname.includes("gridGuardArsenal")}
      className={`text-xs md:text-sm tracking-widest uppercase ${
        ggaEnabled ? "visible" : "invisible"
      } ${
        location && location.pathname.includes("gridGuardArsenal")
          ? "cursor-not-allowed text-warning border-warning"
          : "text-cyber-accent border-cyber-accent"
      } border rounded flex p-2 gap-2 items-center hover:scale-105 hover:bg-cyber-panel transition-all ease-out delay-100`}
      onClick={() => handleGGANav()}
    >
      <FontAwesomeIcon icon={faShield} />
      GridGuard Arsenal
    </button>
  );
};
export default GGABtn;
